import React from 'react';
import styles from './Input.module.css';

const Input = ({ 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  className = '', 
  disabled = false,
  ...props 
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <input
      type={type}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      className={`${styles.input} ${className}`}
      {...props}
    />
  );
};

export default Input;
